import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import moment from "moment";
import localization from "moment/locale/bs";

import { SoftUIControllerProvider } from "context";
import AdminApp from "app/AdminApp";
import UserApp from "app/UserApp";
import TagManager from "react-gtm-module";
import ErrorBoundary from "app/components/error-boundary/ErrorBoundary";

import "index.css";
import UnderMaintenance from "pages/user/under-maintenance";
import { CssBaseline, ThemeProvider } from "@mui/material";
import SoftBox from "components/SoftBox";
import theme from "assets/theme";

const isAdminApp = window.location.hostname.startsWith("platform");

const tagManagerArgs = {
  gtmId: "GTM-5PHXQQ2G",
  dataLayer: { app: isAdminApp ? "platform" : "user" },
};

if (process.env.REACT_APP_ENV === "production") {
  TagManager.initialize(tagManagerArgs);
  console.log("GTM is initialized");
} else {
  console.log("GTM is disabled in development mode");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
moment.locale("bs", localization);

const MAINTENANCE = String(process.env.REACT_APP_MAINTENANCE) === "1";
const BYPASS_KEY = "mz5:maintenance";

function setBypassFromQuery() {
  const p = new URLSearchParams(window.location.search);
  if (p.get("maintenance") === "0") {
    localStorage.setItem(BYPASS_KEY, "0");
    p.delete("maintenance");
    const url = `${window.location.pathname}${p.toString() ? `?${p}` : ""}${window.location.hash}`;
    window.history.replaceState({}, "", url);
  }
}

function hasBypass() {
  return localStorage.getItem(BYPASS_KEY) === "0";
}

setBypassFromQuery();

const getSubdomain = () => {
  const x = window.location.hostname.split(".")[0];
  return x === "localhost" ? "" : x;
};

const shouldShowMaintenance = MAINTENANCE && !hasBypass();

root.render(
  <BrowserRouter>
    <SoftUIControllerProvider>
      <ErrorBoundary>
        {shouldShowMaintenance ? (
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <SoftBox
              sx={{
                backgroundColor: "#ffffff",
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <UnderMaintenance />
            </SoftBox>
          </ThemeProvider>
        ) : getSubdomain() === "platform" ? (
          <AdminApp />
        ) : (
          <UserApp />
        )}
      </ErrorBoundary>
    </SoftUIControllerProvider>
  </BrowserRouter>
);
